/*
 * @Author: zjt
 * @Email: 13928932429@163.com
 * @Date: 2020-08-04 14:46:18
 * @LastEditTime: 2020-08-11 11:47:21
 * @Description: 采购订单api
 */
import axios from '@/utils/axios'

export const getPurchases = (payload) => {
    return axios.get('/calcPurchase', {
        params: payload
    })
}

export const getRawMaterialLatestPurchases = (payload) => {
    return axios.get('/raw_material_latest_purchase', {
        params: payload
    })
}

export const createPurchase = (data) => {
    return axios.post('/calcPurchase', data)
}

export const updatePurchase = (data) => {
    return axios.put('/purchase', data)
}

export const deletePurchase = (id) => {
    return axios.delete(`/calcPurchase/${id}`)
}